/**
 * Created by Mark on 22/04/2017.
 */

import LanguageStore from '../store/language-store.js';

class ContentNavigation {



    get Methods() {
        return ;
    }

    set name(newName){
        if(newName){
            this._name = newName;
        }
    }


    filterLanguages(languages){
        LanguageStore.getLearningLanguage().filter(function(language){
            return languages.indexOf(language.getID()) > -1;
        })
    }

}

export default ContentNavigation;


// WEBPACK FOOTER //
// ./src/classes/content-navigation.js